import { connect } from "react-redux";
import EditMrf from "./editMrf";
import { bindActionCreators } from "redux";
import {getMrfDetailsByGate, deleteMrfDetail, updateMrfDetails} from "services/redux/installation/materialRequisition/action";
import { getMateriaById } from "services/redux/sales/postSales/corporate/action";

const mapStateToProps = (state) => ({
  mrfDetailsByGate : state.mrfDetailsReducer.mrfDetailsByGate,
  getMaterial: state.coporatePostLeadReducer.getMaterial,
  getBrand: state.coporatePostLeadReducer.getBrand,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getMrfDetailsByGate,
      deleteMrfDetail,
      getMateriaById,
      updateMrfDetails
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EditMrf);
